import { IconButton, List, ListItem, Popover, Typography } from "@mui/material";
import { Icon } from "../../../utils/MuiIcons/Icon";
import { useState } from "react";

const ActionsMenu = ({ data, clearColumns, resetTable, openBulkLoad }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const { component } = data || {};
  const { menu, sName } = component || {};

  // Menu configuration
  const menuItems = [
    {
      key: "resetTable",
      label: "Reset Table",
      onClick: () => {
        resetTable();
      },
    },
    {
      key: "clearValues",
      label: component?.clearValues?.sSubmenuCaption,
      onClick: () => {
        clearColumns(data?.component?.clearValues);
      },
    },
    {
      key: "defaultLoad",
      label: component?.defaultLoad?.sSubmenuCaption,
      onClick: () => {
        /* default load logic */
      },
    },
    {
      key: "bulkLoad",
      label: component?.bulkLoad?.sSubmenuCaption,
      onClick: () => {
        openBulkLoad?.("bulkLoad");
      },
    },
    {
      key: "bulkLoad2",
      label: component?.bulkLoad2?.sSubmenuCaption,
      onClick: () => {
        openBulkLoad?.("bulkLoad2");
      },
    },
    {
      key: "bulkLoad3",
      label: component?.bulkLoad3?.sSubmenuCaption,
      onClick: () => {
        openBulkLoad?.("bulkLoad3");
      },
    },
    {
      key: "loadFromFile",
      label: component?.loadFromFile?.sSubmenuCaption,
      onClick: () => {
        /* load from file logic */
      },
    },
  ];

  return (
    <>
      {menu?.bEnabled && (
        <>
          <IconButton sx={{ cursor: "pointer" }} onClick={handleOpen}>
            <Icon iconName={menu?.sIcon} dataSProps={menu?.sIconProps} />
            <Typography id={`${sName}-actions`} {...menu?.sLabelProps}>
              {menu?.sMenuCaption}
            </Typography>
          </IconButton>

          <Popover
            id="actions-popover"
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <List>
              {menuItems
                .filter(({ key }) => component?.[key]?.bEnabled)
                .map(({ key, label, onClick }, index) => (
                  <ListItem key={key} className="cursor-pointer">
                    <Typography
                      id={`${sName}-actions-${index + 1}`}
                      className="cursor-pointer"
                      onClick={() => {
                        onClick();
                        handleClose();
                      }}
                    >
                      {label}
                    </Typography>
                  </ListItem>
                ))}
            </List>
          </Popover>
        </>
      )}
    </>
  );
};

export default ActionsMenu;
